import type { QueryClient, QueryKey } from '@tanstack/react-query'
import { ApiError } from './request'

// Оптимистичная мутация (docs/design §4): отменяем инфлайт-запросы по ключам,
// снимаем снапшот кэша и возвращаем откатчик. onMutate после этого пишет
// оптимистичное состояние через setQueryData, onError зовёт rollback, onSettled —
// invalidate. Несколько ключей — take трогает и task-detail, и board-список, и rollup.
export async function beginOptimistic(qc: QueryClient, keys: QueryKey[]): Promise<() => void> {
  await Promise.all(keys.map((key) => qc.cancelQueries({ queryKey: key })))
  const snapshots = keys.map((key) => [key, qc.getQueryData(key)] as const)
  return () => {
    for (const [key, data] of snapshots) qc.setQueryData(key, data)
  }
}

// Человеческий текст по машинному коду RFC7807 (UPPER_SNAKE). Схемные 422-ошибки
// huma кода не несут — их показываем inline под полем, не тостом (docs/design §Ошибки).
export function apiErrorText(
  error: unknown,
  map: Record<string, string>,
  fallback: string,
): string {
  if (error instanceof ApiError && error.code) {
    const text = map[error.code.toUpperCase()]
    if (text) return text
  }
  return fallback
}
